import React, {useEffect, useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import api from '../../common/api'
import LinearProgress from '@material-ui/core/LinearProgress';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {AppProgressBar} from '../../components';

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
        backgroundColor: '#fffaf2'
    },
    card: {
        width: '100%',
        maxWidth: 460,
        padding: theme.spacing(5),
        textAlign: 'center',
        backgroundColor: '#ffffff',
        borderRadius: 16,
        boxShadow: '0 8px 24px rgba(44, 62, 80, 0.08)',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(4, 3)
        }
    },
    iconCircle: {
        width: 72,
        height: 72,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#fff1db'
    },
    icon: {
        fontSize: 36,
        color: '#f39c12'
    },
    failureCircle: {
        backgroundColor: '#fdecea'
    },
    failureIcon: {
        color: '#e74c3c'
    },
    title: {
        marginTop: theme.spacing(3),
        color: '#2c3e50',
        fontWeight: 600
    },
    message: {
        marginTop: theme.spacing(1.5),
        lineHeight: 1.6
    },
    successText: {
        marginTop: theme.spacing(3),
        color: '#2c3e50',
        fontSize: 18,
        fontWeight: 600,
        lineHeight: 1.5
    },
    progress: {
        marginTop: theme.spacing(3),
        height: 6,
        borderRadius: 3,
        backgroundColor: '#fff1db'
    },
    progressBar: {
        backgroundColor: '#f39c12'
    }
}));

const FailureText = ({apiErrorText, classes}) => <React.Fragment>
    <div className={`${classes.iconCircle} ${classes.failureCircle}`}>
        <ErrorOutlineIcon className={`${classes.icon} ${classes.failureIcon}`}/>
    </div>
    <Typography className={classes.title} variant="h2">
        Activation Failed
    </Typography>
    <Typography className={classes.message} variant="body1" color="textSecondary">
        {apiErrorText}
    </Typography>
</React.Fragment>;
const SuccessText = ({classes}) => <React.Fragment>
    <div className={classes.iconCircle}>
        <CheckCircleOutlineIcon className={classes.icon}/>
    </div>
    <Typography className={classes.successText} variant="h4">
        Your account has been activated, you will be redirected to the login page.
    </Typography>
    <LinearProgress
        classes={{
            root: classes.progress,
            colorPrimary: classes.progress,
            barColorPrimary: classes.progressBar
        }}
    />
</React.Fragment>;

const Activate = ({match, history}) => {
    const classes = useStyles();
    const key = match.params['key'];

    const [loading, setLoading] = useState(true);
    const [apiErrorText, setApiErrorText] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        setApiErrorText(undefined);

        const response = api.get('activate/' + key);
        response.catch(err => {
            if (err.message) {
                if (err.message === 'Request Not Found')
                    setApiErrorText('Invalid Activation Key');
                else
                    setApiErrorText(err.message)
            } else {
                setApiErrorText('Unknown Error')
            }
            setLoading(false);
        });

        response.then(res => {
            if (res === true) {
                setLoading(false);
                setTimeout(() => {
                    history.push('/sign-in');
                }, 4000);

            }
        });
    }, [key, history]);

    return (
        <div className={classes.root}>
            <div className={classes.card}>
                {
                    loading ?
                        <AppProgressBar loading={loading}/>
                        : apiErrorText ?
                        <FailureText apiErrorText={apiErrorText} classes={classes}/> :
                        <SuccessText classes={classes}/>
                }
            </div>
        </div>
    );
};


export default Activate;